<template>
  <tr>
    <td class="body-2-bold break-words py-12">
      {{ title }}
    </td>
    <td class="py-12">
      <p class="flex justify-center">
        <IconCheckLarge
          v-if="isFirstOptionChecked"
          class="text-static-success-hi"
        />
        <IconCross v-else class="text-static-danger-hi" />
      </p>
    </td>
    <td class="py-12">
      <p class="flex justify-center">
        <IconCheckLarge
          v-if="isSecondOptionChecked"
          class="text-static-success-hi"
        />
        <IconCross v-else class="text-static-danger-hi" />
      </p>
    </td>
  </tr>
</template>

<script setup lang="ts">
import { IconCheckLarge } from '@ds/icons/IconCheckLarge'
import { IconCross } from '@ds/icons/IconCross'

defineProps<{
  title: string
  isFirstOptionChecked: boolean
  isSecondOptionChecked: boolean
}>()
</script>
